/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 10/9/2021
 */
import BillingItem, {MilestoneType} from "@shared/Billing/BillingItem";
import {BillingType} from "@shared/Billing/BillingData";
import RecurringInterval from "@shared/Billing/RecurringInterval";
import SubscriptionStatusEnum from "@shared/Billing/SubscriptionStatusEnum";
import dayjs from 'dayjs'


export default class RecurringBillingItem extends BillingItem {

	type: string = "RecurringBillingItem"

	stripeSubscriptionId: string = ""
	stripeProductId: string = ""
	stripePriceId: string = ""

	stripePriceDataItemId: string = "" //technical stripe data for subscription to update price, ie upgrade/downgrade

	hasSetupFee: boolean = false
	setupFeeAmount: string = ""
	setupFeeDescription: string = "One-time setup fee"

	recurringAmount: number = 0
	recurringInterval: string = RecurringInterval.MONTH
	recurringIntervalCount: number = 1

	subscriptionStatus: string = SubscriptionStatusEnum.NOT_SET
	validThroughTs: number = 0

	isEnabled: boolean = false


	constructor() {
		super(0, "", BillingType.RECURRING);
		this.milestoneType = MilestoneType.RECURRING
	}

	isActive(){
		return this.subscriptionStatus.toLowerCase() === SubscriptionStatusEnum.ACTIVE
	}
	isNotSet(){
		return this.subscriptionStatus.toLowerCase() === SubscriptionStatusEnum.NOT_SET
	}

	nextChargeFormatted(format = "MMM DD, YYYY"){
		return dayjs(this.validThroughTs).format(format)
	}
}
